
export const ELECTIVE_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    subject_name: "Viva-voce",
    credits: 4,
    priority: 1,
  },

  ELECTIVE_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Elective Section Title",
      value: "Electives List",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Elective Section Title",
      required: false,
      defaultValue: "Electives List",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "sub_title",
      label: "Sub Title",
      value: "Management is the combined efforts of people within a process to achieve.",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter sub title",
      required: false,
      defaultValue: "Management is the combined efforts of people within a process to achieve.",
    },
    {
      fieldName: "sub_title_text_color",
      label: "Sub Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter sub title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Elective Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Elective Section",
      required: false,
      defaultValue: false,
    },
  ],

  // Category fields configuration for Form_3
  CATEGORY_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Category Name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter category name (e.g., Marketing, Finance, HRM)",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "name_text_color",
      label: "Category Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter category text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "section_color",
      label: "Section Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter section color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "selected_section_color",
      label: "Selected Section Color",
      value: "#E8E8E8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter selected section color (e.g., #E8E8E8)",
      required: false,
      defaultValue: "#E8E8E8",
    },
    {
      fieldName: "selected_section_strip_color",
      label: "Selected Section Strip Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter selected section strip color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "header_section_color",
      label: "Header Section Color",
      value: "#F5F5F5",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter header section color (e.g., #F5F5F5)",
      required: false,
      defaultValue: "#F5F5F5",
    },
    {
      fieldName: "subject_container_color",
      label: "Subject Container Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter subject container color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "order_index",
      label: "Display Order",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter display order (1, 2, 3...)",
      required: true,
      defaultValue: 1,
    },
    {
      fieldName: "status",
      label: "Category Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable category",
      defaultValue: true,
    },
  ],

  // Semester fields configuration for Form_3
  SEMESTER_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Semester Name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter semester name (e.g., Semester 3, Semester 4)",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "name_color",
      label: "Semester Name Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter semester name color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "credits_text",
      label: "Credits Text",
      value: "Credits",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter credits text (e.g., Credits)",
      required: false,
      defaultValue: "Credits",
    },
    {
      fieldName: "credits_text_color",
      label: "Credits Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter credits text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "header_section_color",
      label: "Header Section Color",
      value: "#F5F5F5",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter header section color (e.g., #F5F5F5)",
      required: false,
      defaultValue: "#F5F5F5",
    },
    {
      fieldName: "subject_container_color",
      label: "Subject Container Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter subject container color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "order_index",
      label: "Display Order",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter display order (1, 2, 3...)",
      required: true,
      defaultValue: 1,
    },
    {
      fieldName: "status",
      label: "Semester Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable semester",
      defaultValue: true,
    },
  ],

  // Subject table fields configuration for Form_3
  SUBJECT_TABLE_FIELDS_CONFIG: [
    {
      header: "Subject Name",
      fieldName: "subject_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter subject name",
      required: true,
    },
    {
      header: "Subject Name Text Color",
      fieldName: "subject_name_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter subject name text color (e.g., #000000)",
      required: false,
    },
    {
      header: "Credits",
      fieldName: "credits",
      value: 0,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter credits",
      required: true,
    },
    {
      header: "Credits Text Color",
      fieldName: "credits_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter credits text color (e.g., #000000)",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter priority (1, 2, 3...)",
      required: true,
    },
  ],
};

